export var CostType;
(function (CostType) {
    CostType["CustomersImpacted"] = "customers_impacted";
    CostType["Financial"] = "financial";
    CostType["Hours"] = "hours";
    CostType["Number"] = "number";
})(CostType || (CostType = {}));
//# sourceMappingURL=cost-type.js.map